module.exports = __webpack_public_path__ + "img/window-2.8d649a63.jpg";